import { OnChanges, OnInit, signal } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Enums } from '../../../shared/enums';
import { Utils } from '../../../shared/utils';
import { IMPORTS } from './_imports';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class FileUploadComponent implements OnInit, OnChanges {
    // #region [signals]
    $allowedExtensions = signal([] as string[]);
    $disabled = signal(false);
    $fileName = signal(null as string);
    $mimeType = signal('');
    $drawInput = signal(true);
    // #endregion

    // #region [Input/Output]
    @Input('allowedExtensions') _allowedExtensions: string[] = [];
    @Input('maxSizeMb') _maxSizeMb: number = 15;
    @Input('disabled') _disabled: boolean;
    @Input('value') _value: any;
    @Output('valueChange') _valueChange = new EventEmitter<any>();
    // #endregion

    constructor(private toastr: ToastrService) { }

    ngOnInit() {
        for (let extension of this.$allowedExtensions()) {
            this.$mimeType.set(this.$mimeType() + `.${extension.toLowerCase()},`);
        }

        if (this.$mimeType() == '') {
            this.$mimeType.set('application/octet-stream');
        }
    }

    ngOnChanges() {
        this.$allowedExtensions.set(this._allowedExtensions);
        this.$disabled.set(this._disabled);
    }

    changeFile(event) {
        const file = event.target.files[0] as File;

        // caso a extensão do arquivo não seja permitida
        if (!this.$allowedExtensions().includes(file.name.split('.').slice(-1)[0].toLowerCase())) {
            // reinicia valores do input e do componente Formio
            this.removeFile(event);
            this.toastr.error(Enums.Messages.InvalidFileExtension.replace('{0}', this.$allowedExtensions().join('; ').toUpperCase()), Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        // caso o tamanho do arquivo seja maior que o máximo estabelecido
        if (file.size > this._maxSizeMb * 1024 * 1024) {
            // reinicia valores do input e do componente Formio
            this.removeFile(event);
            this.toastr.error(Enums.Messages.FileMaxSizeLimit.replace('{0}', this._maxSizeMb.toString()), Enums.Messages.Error, Utils.getToastrErrorOptions());
            return;
        }

        let fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);
        fileReader.onloadend = () => {
            // converte o arquivo para um array de bytes, uma vez que o "JSON.stringify > JSON.parse"
            // que ocorre no meio do caminho até o hook do evento de submit do Formio
            // transformaria o objeto do tipo File em um objeto vazio ("{}")
            let byteArray = [];
            let array = new Uint8Array(fileReader.result as ArrayBuffer);
            for (let byte of array) {
                byteArray.push(byte);
            }

            this.$fileName.set(file.name);
            this._value = {
                isCustomFileComponent: true,
                fileName: [file.name],
                fileType: [file.type],
                fileContent: [byteArray]
            };
            this._valueChange.emit(this._value);
        };
    }

    removeFile(event) {
        event.target.value = '';
        this.$fileName.set(null);
        this._value = {};
        this._valueChange.emit(this._value);

        // workaround usando "component recycling" para comportamento impreciso da tag "input[file]" ao sofrer reset de valor
        this.$drawInput.set(false);
        setTimeout(() => this.$drawInput.set(true), 1);
    }

    // #region [===== private methods =====]
    // #endregion
}
